import { Injectable, inject } from '@angular/core';
import { ConfigService } from '@app/shared/services/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class PasswordBaseService {
  public apiUrl = '';
  public returnUrl = `?returnUrl=${encodeURI(window.location.href)}`;
  public configService = inject(ConfigService);

  replaceWindowUrl(openInNewTab: boolean) {
    if (openInNewTab) {
      window.open(this.getUrl(), "", "width=500, height=500");
      return;
    }
    window.location.replace(this.getUrl());
  }

  getUrl(): string {
    return `${this.configService.config.authorityUri}${this.apiUrl}${this.returnUrl}`;
  }
}
